<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/s5XQ61/tc-custom/9780226313443.jpg?1733116140656" alt="This image is the cover for the book Doctors and Demonstrators"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Doctors and Demonstrators
      </h1>
      <p class="bookDescription body article font2">
        <p>Since <i>Roe v. Wade</i>, abortion has continued to be a divisive political issue in the United States. In contrast, it has remained primarily a medical issue in Britain and Canada despite the countries’ shared heritage. <i>Doctors and Demonstrators</i> looks beyond simplistic cultural or religious explanations to find out why abortion politics and policies differ so dramatically in these otherwise similar countries. Drew Halfmann argues that political institutions are the key. In the United States, federalism, judicial review, and a private health care system contributed to the public definition of abortion as an individual right rather than a medical necessity. Meanwhile, Halfmann explains, the porous structure of American political parties gave pro-choice and pro-life groups the opportunity to move the issue onto the political agenda. A groundbreaking study of the complex legal and political factors behind the evolution of abortion policy, <i>Doctors and Demonstrators</i> will be vital for anyone trying to understand this contentious issue.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Drew Halfmann
      </h2>
      
      <p class="authorDescription body article"><B>Drew Halfmann</B> is associate professor of sociology at the University of California, Davis.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?57ef3025